import { ReactElement } from 'react';
import { Stack } from '@mui/material';

import { DashboardVariantV2CarrierHeaderExpandMore } from './SubComponents';

import DashboardVariantV2CarrierHeaderWidgets from './Widgets';

const DashboardVariantV2CarrierHeader = (): ReactElement => (
  <DashboardVariantV2CarrierHeaderExpandMore.Provider>
    <Stack spacing={2}>
      <DashboardVariantV2CarrierHeaderWidgets />

      <DashboardVariantV2CarrierHeaderExpandMore.Divider />
    </Stack>
  </DashboardVariantV2CarrierHeaderExpandMore.Provider>
);

export default DashboardVariantV2CarrierHeader;
